<template>
    <div>
        <div>
            <div v-if="!isLoading" class="payment-wrapper">
                <iframe
                    :src="paymentUrl"
                    id="pc-frame"
                    name="pc-frame"
                    frameborder="0"
                    class="payment-frame"
                    @load="frameChanged()"
                ></iframe>
            </div>
        </div>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </div>
</template>

<script>
import AxiosClient from "@/app/shared/services/http-client/axios";
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "PaymentCenterOrder",
    props: ["userId", "onSuccess", "onDecline", "onCancel"],
    components: { OverlayLoader },
    data() {
        return {
            isLoading: false,
            formData: {},
            paymentUrl: undefined,
            endpoints: {},
        };
    },
    created() {
        this.newPayment();
    },
    methods: {
        newPayment() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;
                AxiosClient.get("/payment/payment-token", {
                    params: { user_id: this.userId },
                })
                    .then((response) => {
                        this.paymentUrl = response.data.url;
                        this.endpoints = this.reverseObject(response.data.endpoints);
                        resolve(response.data.url);
                    })
                    .catch(() => reject())
                    .finally(() => (this.isLoading = false));
            });
        },
        frameChanged() {
            const callbacks = {
                success_url: this.onSuccess,
                decline_url: this.onDecline,
                cancel_url: this.onCancel,
            };
            const frame = document.getElementById("pc-frame");
            let framePath = undefined;
            try {
                framePath =
                    frame.contentWindow.location.origin + frame.contentWindow.location.pathname;
            } catch (error) {}
            if (this.endpoints.hasOwnProperty(framePath) && callbacks[this.endpoints[framePath]]) {
                callbacks[this.endpoints[framePath]]();
                if (["decline_url", "cancel_url"].includes(this.endpoints[framePath]))
                    this.newPayment().then((url) => (frame.src = url));
            }
        },
        reverseObject(obj) {
            const reversed = {};
            Object.keys(obj).forEach((key) => {
                reversed[obj[key]] = key;
            });
            return reversed;
        },
    },
};
</script>

<style>
.payment-wrapper {
    max-width: 450px;
    margin: 0 auto;
}
.payment-frame {
    width: 100%;
    height: 538px;
}
</style>
